import { Component, Input, OnInit } from '@angular/core';
import { Empty_LetterRequestCustomer_Schedule_Interface, LetterRequestCustomer_Schedule_Interface } from 'src/app/Interface/LetterRequestCustomer_Schedule_Interface';
import { LetterRequestCustomerScheduleServiceService } from 'src/app/Service/Letter/LetterRequestCustomerScheduleService.service';


@Component({
  selector: 'app-ScheduleLetterModirView',
  templateUrl: './ScheduleLetterModirView.component.html',
  styleUrls: ['./ScheduleLetterModirView.component.css']
})
export class ScheduleLetterModirViewComponent implements OnInit {

  @Input() inner_schedule_id:number=0
  Token:String=""

  constructor(
    private LetterRequestCustomerSchedule_Service:LetterRequestCustomerScheduleServiceService,

  ) { }

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');
    this.GetModirSignle()
  }

  Selected_Schedule_Record:  LetterRequestCustomer_Schedule_Interface=Empty_LetterRequestCustomer_Schedule_Interface();

  GetModirSignle(){

    this.LetterRequestCustomerSchedule_Service.GetModirSignle(this.Token,this.inner_schedule_id).subscribe(
      data=>{

        this.Selected_Schedule_Record=data

      },error=>{
        localStorage.clear()
        location.reload();
        
      }
    )
  }
}
